<template>
  <div class="product-details-content-certificate-preview">
    <div class="position-relative">
      <svg
        v-if="template"
        width="100%"
        viewBox="0 0 1123 794"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <image
          x="0"
          y="0"
          width="100%"
          height="100%"
          preserveAspectRatio="xMinYMin slice"
          :href="template"
        />
      </svg>
      <svg
        v-else
        width="100%"
        viewBox="0 0 1123 794"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="1123" height="794" fill="#E5E5E5" />
        <g clip-path="url(#clip0_7880_161042)">
          <rect width="1123" height="794" fill="#F7F7F9" />
          <path
            d="M14.9999 777V15.5H1107V777H14.9999Z"
            stroke="url(#paint1_linear_7880_161042)"
            stroke-width="2"
          />
          <path
            d="M32.9999 32.9827L33.7874 759.482L1089 759.127V33"
            stroke="url(#paint2_linear_7880_161042)"
            stroke-width="2"
          />
          <path
            d="M14 778.5V494L248.113 778.5H14Z"
            fill="url(#paint3_linear_7880_161042)"
          />
          <path d="M33 651V759H144" stroke="white" stroke-width="1.37378" />
          <path
            d="M941 201.5L311.475 20.6835L163.238 108.7L14 197V14.5H1108L941 201.5Z"
            fill="url(#paint4_linear_7880_161042)"
          />
          <path
            d="M141 33L33 33L33 144"
            stroke="white"
            stroke-width="1.37378"
          />
          <path
            d="M944.498 286.117C944.498 286.044 944.425 286.044 944.425 285.972C944.425 285.899 944.351 285.899 944.278 285.899H942.665C942.592 285.899 942.518 285.899 942.518 285.972C942.445 286.044 942.445 286.044 942.445 286.117V290.106C942.445 290.179 942.445 290.251 942.518 290.251C942.592 290.324 942.592 290.324 942.665 290.324C942.738 290.324 942.812 290.324 942.812 290.251C942.885 290.179 942.885 290.179 942.885 290.106V288.075H944.131L944.205 288.366C944.205 288.438 944.351 288.511 944.425 288.511H945.598C945.671 288.511 945.745 288.511 945.745 288.438C945.818 288.366 945.818 288.366 945.818 288.293V286.552C945.818 286.48 945.818 286.407 945.745 286.407C945.671 286.335 945.671 286.335 945.598 286.335H944.571L944.498 286.117Z"
            fill="white"
          />
          <path
            d="M945.305 294.458L943.032 289.381C942.885 289.091 942.372 289.236 942.225 289.671L934.82 307.442H939.952L945.305 294.458Z"
            fill="white"
          />
          <path
            d="M952.417 294.458H946.331L951.317 305.484C951.977 304.831 952.564 304.106 952.93 303.235L954.837 298.593C955.79 296.344 954.69 294.458 952.417 294.458Z"
            fill="white"
          />
          <path
            d="M950.584 306.064L945.305 294.458L934.82 307.37H946.991C948.238 307.37 949.484 306.862 950.584 306.064Z"
            fill="white"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_7880_161042"
            x1="876.088"
            y1="696.309"
            x2="916.834"
            y2="696.309"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#EE6469" />
            <stop offset="1" stop-color="#5576ec" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_7880_161042"
            x1="33.029"
            y1="458"
            x2="569.904"
            y2="19.626"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.618988" :stop-color="color_1" />
            <stop offset="0.850631" :stop-color="color_2" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_7880_161042"
            x1="40.7949"
            y1="448"
            x2="554.345"
            y2="22.3788"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.618988" :stop-color="color_1" />
            <stop offset="0.850631" :stop-color="color_2" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_7880_161042"
            x1="33.4784"
            y1="455.872"
            x2="610.739"
            y2="197.249"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.00016548" :stop-color="color_1" />
            <stop offset="0.95" :stop-color="color_2" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_7880_161042"
            x1="9"
            y1="368.5"
            x2="50.1861"
            y2="-39.1077"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.6628" :stop-color="color_1" />
            <stop offset="0.985193" :stop-color="color_2" />
          </linearGradient>
          <linearGradient
            id="paint5_linear_7880_161042"
            x1="10.608"
            y1="824.243"
            x2="1178.96"
            y2="325.973"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.768527" :stop-color="color_1" />
            <stop offset="0.80858" :stop-color="color_1" />
            <stop offset="0.860181" :stop-color="color_2" />
          </linearGradient>
          <clipPath id="clip0_7880_161042">
            <rect width="1123" height="794" fill="white" />
          </clipPath>
          <clipPath id="clip1_7880_161042">
            <rect
              width="181.048"
              height="54.8285"
              fill="white"
              transform="translate(876 672.725)"
            />
          </clipPath>
        </defs>
      </svg>

      <div class="body" :style="bodyStyle">
        <h1 v-if="typography === 'Parisienne' || typography === 'Great Vibes'">
          Certificado
        </h1>
        <h1 v-else>CERTIFICADO</h1>
        <div class="text">
          Certificamos para os devidos fins, que
          <br />
          <strong>
            Nome do aluno
          </strong>
          <br />
          concluiu com êxito o curso online <br />
          <strong> {{ courseName || "Curso Exemplo" }} </strong>
          .
        </div>
        <div class="finished-at">
          Realizado no período de &nbsp;<strong>19/04/2023</strong>
          &nbsp;a&nbsp; <strong>21/04/2023</strong> &nbsp;cumprindo <br />
          uma carga horária de &nbsp;<strong
            >{{ hourly_load || "15" }}&nbsp;horas.</strong
          >
        </div>
        <div class="box-signature">
          <img
            v-if="image_signature"
            class="signature"
            :src="image_signature"
          />
          <span v-else class="signature" :style="signatureStyle">
            {{ organizer_name || $config.get("title") }}
          </span>

          <div class="organizer">
            {{ organizer_name || $config.get("title") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    courseName: {
      type: String
    },
    hourly_load: {
      type: [Number, String]
    },
    organizer_name: {
      type: String
    },
    image_signature: {
      type: String
    },
    color_1: {
      type: String
    },
    color_2: {
      type: String
    },
    typography: {
      type: String
    },
    textColor: {
      type: String
    },
    template: {
      type: String,
      default: ""
    },
    signature_typography: String
  },
  computed: {
    bodyStyle() {
      return {
        "font-family": this.typography,
        color: this.textColor
      };
    },
    signatureStyle() {
      return {
        "font-family": this.signature_typography || this.typography
      };
    }
  }
};
</script>

<style lang="scss" scoped>
// body fonts
@import url("https://fonts.googleapis.com/css?family=Bellota&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Voces&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Poiret+One&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Parisienne&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Simonetta&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Great+Vibes&display=swap");

// signature fonts
@import url("https://fonts.googleapis.com/css2?family=Whisper&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Allison&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Ms+Madi&display=swap");

.product-details-content-certificate-preview {
  .body {
    position: absolute;
    top: 19%;
    left: 15%;
    right: 15%;
    text-align: center;
  }

  h1 {
    font-weight: 700;
    font-size: 30px;
    margin-bottom: 24px;
    @media screen and (max-width: 1199px) {
      margin-bottom: 2vw;
      line-height: 150%;
      font-size: 3vw;
    }
    @media screen and (max-width: 991px) {
      font-size: 5vw;
    }
  }

  .text {
    width: 80%;
    margin: 5px 10% 30px;
    font-size: 12px;
    @media screen and (max-width: 1199px) {
      line-height: 160%;
      font-size: 1.5vw;
    }
    @media screen and (max-width: 991px) {
      font-size: 2vw;
    }
  }

  .finished-at {
    font-size: 9.6px;
    @media screen and (max-width: 1199px) {
      font-size: 1.3vw;
    }
    @media screen and (max-width: 991px) {
      font-size: 1.8vw;
    }
  }

  strong {
    filter: brightness(0.9);
  }

  .organizer {
    width: 35%;
    border-top: 1px solid #d2d0d8;
    margin: 0 25%;
    font-weight: 700;
    font-size: 9.6px;
    padding-top: 10px;
    display: block;
    @media screen and (max-width: 1199px) {
      line-height: 150%;
      font-size: 1.2vw;
    }
    @media screen and (max-width: 991px) {
      font-size: 1.5vw;
    }
  }

  .box-signature {
    height: 85px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    @media screen and (max-width: 1199px) {
      height: 10vw;
    }
    @media screen and (max-width: 991px) {
      height: 13vw;
    }
    @media screen and (max-width: 780px) {
      height: 11vw;
    }
  }
  .signature {
    padding-top: 24px;
    max-width: 450px;
    max-height: 50px;
    margin-top: 21px;
    font-size: 12px;
    white-space: nowrap;

    @media screen and (max-width: 1400px) {
      max-height: 40px;
    }
    @media screen and (max-width: 991px) {
      max-height: 45px;
    }
    @media screen and (max-width: 420px) {
      max-height: 35px;
    }
  }

  .empty {
    padding-top: 80px;
  }

  .position-relative {
    box-shadow: 0px 4.99685px 6px rgba(0, 0, 0, 0.1),
      0px 8px 16px 8px rgba(0, 0, 0, 0.05);
  }
}
</style>
